import React from 'react';
import { jwtDecode } from 'jwt-decode';

import HeadlinePanel from '../Components/HeadlinePanel';

import AMApplications from '../Components/TablesForApplicationsPage/AMApplications';
import WorkerApplications from '../Components/TablesForApplicationsPage/WorkerApplications';

import Loading from '../Components/Loading';

export default function Applications() {
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
      setUserRole(decodedToken.role);
    }
  }, []);


  if (!userId || !userRole) {
    return <Loading />;
  }

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Мои заявки' type='' />
        <div className='containerInner'>
          {userRole === 'Арбитражный управляющий' ? (
            <AMApplications userId={userId} isFromAccount={false} />
          ) : (
            <WorkerApplications /> //Заглушка. Этой страницы у аппарата СРО нет
          )}
        </div>
      </div>
    </>
  );
};
